import React, { useEffect } from 'react';
import { Card, Typography, Divider, Descriptions, Row, Col, Breadcrumb, Space, Grid, notification, Empty } from 'antd';
import DateRange from './global/comp/DateRange';
import { useDispatch, useSelector } from 'react-redux';
import { SnippetsOutlined } from '@ant-design/icons';
import { useReportMutation } from '../slices/zerodhaApiSlice';
import { setReports } from '../slices/reportSlice';

const { Title, Text } = Typography;

const ReportScreen = ({ reportData }) => {

    const [api, contextHolder] = notification.useNotification();

    const { date } = useSelector((state) => state.date);
    const { darkmode } = useSelector((state) => state.darkmode);
    const { report } = useSelector((state) => state.report);
    
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const dispatch = useDispatch();

    const [reports, { isLoading: isReportLoading }] = useReportMutation();

    const getReport = async (startDate, endDate) => {
      try {
        const res = await reports({ startDate, endDate }).unwrap();
        dispatch(setReports({ ...res }));
      } catch (err) {
        api.error({
          message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
        });
      }
    };

    useEffect(()=>{
      getReport(date.startDate, date.endDate);
    },[])


  return (
    <div>
      {contextHolder}
      <Title level={2}   style={{ fontFamily: 'Inter, sans-serif', }}><SnippetsOutlined /> Reports</Title>
      {/* <Row  style={{padding: "20px", backgroundColor: darkmode ? "#141414" : "white", borderRadius: "5px"}}>    
        <Col flex={"auto"}>
          <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Reports' }]} style={{marginBottom: "5px"}} />
          <Space direction="horizontal" style={{marginBottom: "10px"}}>
            {!screens.lg ? (<DateRange/>):(<></>)}
          </Space>
        </Col>     
      </Row> */}
      
      <Divider />

      <Card>
        <Descriptions
          title="Report Details"
          bordered
          column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
          layout="vertical"
          loading={isReportLoading}
        >

          {report != null  && Object.keys(report).length !== 0 ? (
            <>            
            <Descriptions.Item label="Best Month">{report.bestMonth}</Descriptions.Item>
            <Descriptions.Item label="Worst Month">{report.worstMonth}</Descriptions.Item>
            <Descriptions.Item label="Total P&L"><Text style={ {color: report.totalPnL > 0 ? "#2ecc71" : "#c0392b" }}>₹ {new Intl.NumberFormat('en-IN').format(report.totalPnL).toLocaleString()}</Text></Descriptions.Item>
            <Descriptions.Item label="Total Trades">{report.totalTrades}</Descriptions.Item>
            <Descriptions.Item label="Total Winning Trades">{report.totalWinningTrades}</Descriptions.Item>
            <Descriptions.Item label="Total Losing Trades">{report.totalLosingTrades}</Descriptions.Item>
            <Descriptions.Item label="Average Volume">{new Intl.NumberFormat('en-IN').format(report?.averageVolume).toLocaleString()}</Descriptions.Item>
            <Descriptions.Item label="Average Daily P&L"><Text style={ {color: report.averageDailyPnL> 0 ? "#2ecc71" : "#c0392b" }}>₹ {new Intl.NumberFormat('en-IN').format(report.averageDailyPnL).toLocaleString()}</Text></Descriptions.Item>
            <Descriptions.Item label="Largest Profit">₹ {new Intl.NumberFormat('en-IN').format(report.largestProfit).toLocaleString()}</Descriptions.Item>
            <Descriptions.Item label="Largest Loss">₹ {new Intl.NumberFormat('en-IN').format(Math.abs(report.largestLoss)).toLocaleString()}</Descriptions.Item>
            
            
            <Descriptions.Item label="Average P&L"><Text style={ {color: report.averagePnL > 0 ? "#2ecc71" : "#c0392b" }}>₹ {new Intl.NumberFormat('en-IN').format(report.averagePnL).toLocaleString()}</Text></Descriptions.Item>
            
            
            
            <Descriptions.Item label="Profit Factor">{Number(report.profitFactor).toFixed(2)}</Descriptions.Item>
            <Descriptions.Item label="Total Trading Days">{report.totalTradingDays}</Descriptions.Item>
            <Descriptions.Item label="Total Winning Days">{report.totalWinningDays}</Descriptions.Item>
            <Descriptions.Item label="Total Losing Days">{report.totalLosingDays}</Descriptions.Item>
            <Descriptions.Item label="Average Hold Time (hrs)">{report.averageHoldTime.toFixed(2)}</Descriptions.Item>
            <Descriptions.Item label="Average Hold Time Wins (hrs)">{report.averageHoldTimeWins.toFixed(2)}</Descriptions.Item>
            <Descriptions.Item label="Average Hold Time Losses (hrs)">{report.averageHoldTimeLosses.toFixed(2)}</Descriptions.Item>
            <Descriptions.Item label="Max Consecutive Wins">{report.maxConsecutiveWins}</Descriptions.Item>
            <Descriptions.Item label="Max Consecutive Losses">{report.maxConsecutiveLosses}</Descriptions.Item>
            <Descriptions.Item label="Open Trades">{report.openTrades}</Descriptions.Item>
            </>
          
          ):(
            <Empty/>
          )}
        </Descriptions>
      </Card>
    </div>
  );
};

export default ReportScreen;
